// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__bkUFp","right":"Footer_right__11HuS","buttons":"Footer_buttons__1YeLO"};